import { useQueryClient } from '@tanstack/react-query';
import { type TransactionItemDetail, createTransactionItemDetail } from 'models';
import { useMutation } from 'query';
import { updateTransactionItem } from '../../services';
import { getTransactionsInfiniteQueryKey } from '../keys';

type UpdateTransactionData = {
  anonymous?: boolean;
  id: string;
  showTextContent?: boolean;
  textContent?: string;
};

export const useUpdateTransactionItemMutation = () => {
  const queryClient = useQueryClient();
  return useMutation<TransactionItemDetail, UpdateTransactionData>({
    async mutationFn({ anonymous, id, showTextContent, textContent }) {
      const response = await updateTransactionItem({
        body: {
          transaction_item: {
            anonymous,
            show_text_content: showTextContent,
            text_content: textContent,
          },
        },
        routeParams: { id },
      });

      return createTransactionItemDetail(response.data);
    },
    async onSuccess() {
      await queryClient.invalidateQueries({ queryKey: getTransactionsInfiniteQueryKey({}) });
    },
  });
};
